export default function PreparationItemCommentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  docDataService,
  editPreparationItemCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Preparation Item Note Added';
  vm.isExpanded = false;
  vm.canEditItem = vm.canEdit;
  vm.canDeleteItem = vm.canDelete;
  vm.handleEditPreparationItemComment = _handleEditPreparationItemComment;
  vm.handleDeletePreparationItemComment = _handleDeletePreparationItemComment;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditPreparationItemComment($event) {
    amDataService.getPreparationItemComment(vm.preparationItemComment.preparationItemCommentId).then((response) => {
      ssDialogService.dialogs.auditTrail.editPreparationItemCommentDialog = ssDialogService.alert(
        editPreparationItemCommentDialog.getOptions($event, {
          preparationItemId: response.data.preparationItemId,
          preparationItemCommentId: response.data.preparationItemCommentId,
          preparationItemCommentText: response.data.text,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.editPreparationItemCommentDialog);
    });
  }

  function _handleDeletePreparationItemComment($event) {
    ssDialogService.dialogs.auditTrail.deletePreparationItemCommentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Preparation Item Note?',
        message: `Are you sure you want to delete Preparation Item Note "${vm.preparationItemComment.text}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deletePreparationItemCommentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.deletePreparationItemComment(vm.preparationItemComment.preparationItemCommentId)
      .then(() => {
        alerts.success('The Preparation Item Note has been deleted successfully.');
        $rootScope.$broadcast('refreshAMPreparationItemComments',
          { preparationItemId: vm.preparationItemComment.preparationItemId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Preparation Item Note.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deletePreparationItemCommentConfirmDialog);
  }
}

PreparationItemCommentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'docDataService',
  'editPreparationItemCommentDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
